module.exports = __webpack_public_path__ + "img/usd.2e3b1da6.svg";